import React, { useEffect, useState } from "react";
import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { LayoutDashboard, Users, Ticket, Send, QrCode, LogOut, MessageSquare, Bot, Truck, KeyRound } from "lucide-react";

const links = [
  { to: "/admin", label: "Áttekintés", icon: LayoutDashboard, end: true, testId: "admin-nav-dashboard" },
  { to: "/admin/subscribers", label: "Feliratkozók", icon: Users, testId: "admin-nav-subscribers" },
  { to: "/admin/pickups", label: "Gyűjtés kérések", icon: Truck, testId: "admin-nav-pickups" },
  { to: "/admin/coupons", label: "Kuponok", icon: Ticket, testId: "admin-nav-coupons" },
  { to: "/admin/qr-cards", label: "QR kártyák", icon: QrCode, testId: "admin-nav-qr" },
  { to: "/admin/newsletter", label: "Hírlevél", icon: Send, testId: "admin-nav-newsletter" },
  { to: "/admin/chat-history", label: "Chat előzmények", icon: MessageSquare, testId: "admin-nav-chat" },
  { to: "/admin/ai", label: "AI asszisztens", icon: Bot, testId: "admin-nav-ai" },
  { to: "/admin/account", label: "Fiók / jelszó", icon: KeyRound, testId: "admin-nav-account" },
];

export default function AdminLayout() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");

  useEffect(() => {
    const token = localStorage.getItem("gb_admin_token");
    if (!token) {
      navigate("/admin/login");
      return;
    }
    api.get("/admin/me").then((r) => setEmail(r.data.email)).catch(() => {});
  }, [navigate]);

  const logout = () => {
    localStorage.removeItem("gb_admin_token");
    localStorage.removeItem("gb_admin_email");
    navigate("/admin/login");
  };

  return (
    <div className="min-h-screen bg-[#FBF8F3] flex">
      <aside className="hidden lg:flex w-64 shrink-0 bg-[#201B18] text-[#FBF8F3] flex-col sticky top-0 h-screen">
        <div className="p-5 border-b border-white/10 flex items-center">
          <span className="font-mono-brand font-black tracking-[0.22em] text-sm inline-flex items-center">
            <span className="text-[#C29B78]">●</span>
            <span className="ml-2">GROWBAG</span>
            <span className="ml-2 text-[9px] font-normal tracking-[0.3em] text-[#8C8075]">ADMIN</span>
          </span>
        </div>
        <nav className="p-3 space-y-1 flex-1">
          {links.map((l) => {
            const Icon = l.icon;
            return (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.end}
                data-testid={l.testId}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium transition-colors ${
                    isActive ? "bg-[#4A6B53] text-white" : "text-[#D7CFC6] hover:bg-white/5"
                  }`
                }
              >
                <Icon className="h-4 w-4" /> {l.label}
              </NavLink>
            );
          })}
        </nav>
        <div className="p-3 border-t border-white/10">
          <p className="text-xs text-[#8C8075] truncate mb-2 px-2">{email}</p>
          <button onClick={logout} data-testid="admin-logout-button" className="w-full flex items-center gap-2 px-3 py-2.5 rounded-xl text-sm font-medium text-[#D7CFC6] hover:bg-white/5">
            <LogOut className="h-4 w-4" /> Kijelentkezés
          </button>
        </div>
      </aside>

      <div className="flex-1 flex flex-col min-w-0">
        <header className="lg:hidden sticky top-0 z-40 glass-header px-4 h-14 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <span className="font-mono-brand text-sm tracking-widest font-bold text-[#2C221E]">GROWBAG</span>
            <span className="chip chip-sage">ADMIN</span>
          </div>
          <button onClick={logout} className="text-sm text-[#5C524A]"><LogOut className="h-4 w-4" /></button>
        </header>
        <nav className="lg:hidden flex overflow-x-auto border-b border-[#2C221E]/10 bg-white px-2 py-2 gap-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              className={({ isActive }) =>
                `whitespace-nowrap px-3 py-1.5 rounded-full text-xs font-semibold ${
                  isActive ? "bg-[#2C221E] text-[#FBF8F3]" : "text-[#5C524A]"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>
        <main className="flex-1 p-4 sm:p-6 lg:p-10">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
